var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "16px",
    viewBox: "0 0 18 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "16.3373132 17 0.844681592 17 0.844681592 0.3143 16.3373132 0.3143"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-51",
    transform: "translate(0.000000, 0.399725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(0.500000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.783,0.5013 L14.346,0.4543 C14.046,0.4393 13.766,0.6913 13.755,1.0063 L13.226,14.4163 L3.912,14.3273 L3.427,0.8663 C3.415,0.5583 3.161,0.3143 2.854,0.3143 L2.836,0.3143 L1.398,0.3603 C1.247,0.3653 1.102,0.4313 0.999,0.5423 C0.894,0.6533 0.84,0.8013 0.845,0.9533 L1.329,14.3713 C1.329,15.8203 2.508,17.0003 3.957,17.0003 L13.226,17.0003 C13.926,17.0003 14.584,16.7283 15.082,16.2333 C15.579,15.7393 15.853,15.0863 15.852,14.4153 L16.337,1.0943 C16.342,0.9423 16.287,0.7943 16.182,0.6833 C16.079,0.5713 15.935,0.5063 15.783,0.5013",
    id: "Fill-37",
    fill: "#3B4365",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.9929211,4.35207144 L7.14943037,4.35207144 L7.25594514,2.64690382 L10.8864064,2.64690382 L10.9929211,4.35207144 Z M17.430594,4.35207144 L13.5801349,4.35207144 L13.2615861,1.05445762 C13.1381484,0.443712487 12.608561,0 12.0033182,0 L6.13903329,0 C5.53379051,0 5.00320761,0.443712487 4.87180622,1.11696677 L4.56221657,4.35207144 L0.569406039,4.35207144 C0.254839066,4.35207144 0,4.61440492 0,4.93822281 L0,6.41384863 C0,6.73766652 0.254839066,7 0.569406039,7 L17.430594,7 C17.7451609,7 18,6.73766652 18,6.41384863 L18,4.93822281 C18,4.61440492 17.7451609,4.35207144 17.430594,4.35207144 Z",
    id: "Fill-42",
    fill: "#3B4365"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    transform: "translate(5.500000, 9.000000)",
    fill: "#3B4365"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6602056,12 C2.41090495,11.9859037 3.01146443,11.3918443 2.99983388,10.6719248 L2.73233116,0.561839235 C2.72387257,0.248699446 2.4542552,0 2.12648506,0 L2.11591183,0 L0.593366667,0.0261788891 C0.432653566,0.0291995301 0.279341727,0.0936398725 0.168322809,0.204396711 C0.0562465679,0.31616043 -0.00402084478,0.464171841 0.000208447338,0.617217654 L0.268768497,10.7222688 C0.281456373,11.4270851 0.893646407,12 1.6602056,12",
    id: "Fill-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99941461,0.62764884 C7.00641028,0.473259334 6.95044491,0.321897074 6.84550984,0.207870838 C6.73857601,0.0948536831 6.59366569,0.0302724521 6.43876154,0.0272452069 L5.00165084,0 L4.99065764,0 C4.68484688,0 4.43300272,0.243188698 4.42001076,0.553985873 L4.0002705,10.6710394 C3.99327483,11.0201816 4.12219505,11.3491423 4.36104725,11.6004036 C4.60089882,11.8506559 4.92170031,11.9929364 5.29147149,12 C5.98903983,12 6.56768177,11.4268416 6.58067373,10.7336024 L6.99941461,0.62764884 Z",
    id: "Fill-44"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.16838609cfe292ef45b92d2194076289.svg";
export { ForwardRef as ReactComponent };